/**
 * Get offset of element relative to document.
 * 
 * @param {element} el 
 * @return {Object} The top and left offset of the element relative to the document
 */
export function getElementOffset(el) {
    let top = 0;
    let left = 0;
    let element = el;

    // Loop through the DOM tree
    // and add it's parent's offset to get page offset
    do {
        top += element.offsetTop || 0;
        left += element.offsetLeft || 0;
        element = element.offsetParent;
    } while (element);

    return {
        top,
        left
    };
}

/**
 * Updates the parameter in current URL.
 * 
 * @param {string} name
 * @param {string} value
 */
export function updateUrlParameter(name, value) {
    let url = new URL(window.location.toString());

    if (!value) {
        url.searchParams.delete(name);
    } else {
        url.searchParams.set(name, value);
    }
    
    window.history.replaceState({path: url.toString()}, '', url.toString());
}

/**
 * Updates the parameter in current URL.
 * 
 * @param {string} name

 */
export function removeParameterFromUrl(name) {
    let url = new URL(window.location.toString());

    url.searchParams.delete(name);
    
    window.history.replaceState({path: url.toString()}, '', url.toString());
}